import { Component } from '@angular/core';
import { ADataPreviewSettings } from '../common/adatapreview.settings';

@Component({
    selector: 'container-web-feed-settings',
    templateUrl: '../../base.list.settings.html'
})
export class ContainerWebFeedSettings extends ADataPreviewSettings {
    getTypeName(): string {
        return 'evidanza.MiddleWare.Shared.Container.ContainerWebFeed';
    }

    getDBTypes(): number[][] {
        return [[256]]; // DataSourceRead
    }

    getResourceBase(): number {
        return 1;
    }

    static GetSettingsEntry() {
        return {
            Caption: '@@ContainerWebFeed',
            ID: 'containerwebfeed',
            Icon: 'globe',
            Index: 60,
            Parent: 'relational',
            Security: {
                Name: 'evidanza.MiddleWare.Shared.Security.RelationalContainerRight',
                Value: 128
            },
            Content: ContainerWebFeedSettings
        }
    }
}